import {
    RolePermission
} from "./permisions.model"

export default new RolePermission([])